<div id="case-accident-opponent" class="container-fluid pb-3">

    <div class="row">

        <!-- LEFT COLUMN WITH LIST -->

        <div class="col-sm-4">
            <mat-card>
                <mat-card-content>

                    <mat-action-list class="smp-action-list">
                        <button id="{{idPrefix}}btn.general"
                                mat-list-item
                                class="smp-action-list-button"
                                [ngClass]="{ 'active': generalTab }"
                                (click)="openParticipant(null)">
                            {{ 'detailed_processing.accident_opponent.tab.general' | translate }}
                        </button>
                    </mat-action-list>

                    <!-- Empty mat-card-title so we simply get the same blue line as the title -->
                    <mat-card-title class="mt-3 mb-3"></mat-card-title>

                    <action-list *ngIf="participants"
                                 [idPrefix]="idPrefix"
                                 [items]="participants.items"
                                 [selected]="selectedParticipant"
                                 [identifier]="'id'"
                                 [options]="actionListOptions"
                                 (select)="openParticipant($event)"
                                 (delete)="deleteParticipant($event)">
                    </action-list>

                    <new-participant *ngIf="newParticipantPanelOpen"
                                     [idPrefix]="(idPrefix + 'new.')"
                                     [title]="'detailed_processing.accident_opponent.title.new_opponent' | translate"
                                     [(panelOpen)]="newParticipantPanelOpen"
                                     [typeSelectOptions]="participantTypeSelectOptions"
                                     [excludedTypes]="excludedParticipantTypes"
                                     [participantTypeUriBuilderParams]="participantTypeUriBuilderParams"
                                     (create)="createParticipant($event)">
                    </new-participant>

                    <button id="{{idPrefix}}btn.open_new_participant_panel"
                            mat-flat-button
                            color="accent"
                            class="w-100 mt-3"
                            *ngIf="!newParticipantPanelOpen"
                            (click)="openNewParticipantPanel()"
                            [disabled]="allTypesCreated(accidentOpponentParticipants.length)">
                        <mat-icon>add</mat-icon>{{ 'detailed_processing.accident_opponent.btn.create' | translate }}
                    </button>

                </mat-card-content>
            </mat-card>
        </div>


        <!-- RIGHT COLUMN WITH CASE DETAILS -->

        <div class="col-sm-8" *ngIf="!selectedParticipant && case">

            <!-- FIRST COLUMN - GENERAL -->
            <mat-card>
                <mat-card-content>
                    <div class="row">

                        <div class="col-md-12 col-lg-6">
                            <div class="row">
                                <div class="col-sm-10">
                                    <vehicle-type-manufacturer-select class="full-width"
                                                                      [idPrefix]="idPrefix"
                                                                      [type]="case.accident.opponent.vehicle_type"
                                                                      [manufacturer]="case.accident.opponent.manufacturer"
                                                                      [manufacturerSelectOptions]="manufacturerSelectOptions"
                                                                      [vehicleTypeSelectOptions]="vehicleTypeSelectOptions"
                                                                      (updated)="patchAndUpdateWithValue($event)">
                                    </vehicle-type-manufacturer-select>
                                </div>
                                <div class="col-sm-2">
                                    <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-10">
                                    <div class="row no-gutters">
                                        <mat-form-field class="full-width">
                                            <mat-label>{{ case.accident.opponent.trans.model | translate }}</mat-label>
                                            <input id="{{idPrefix}}{{case.accident.opponent.trans.model}}"
                                                   type="text" matInput
                                                   [(ngModel)]="case.accident.opponent.model"
                                                   (blur)="patchAndUpdate('accident.opponent.model')">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-10">
                                    <div class="row no-gutters">
                                        <mat-form-field class="full-width">
                                            <mat-label>{{ case.accident.opponent.trans.submodel | translate }}</mat-label>
                                            <input id="{{idPrefix}}{{case.accident.opponent.trans.submodel}}"
                                                   type="text" matInput
                                                   [(ngModel)]="case.accident.opponent.submodel"
                                                   (blur)="patchAndUpdate('accident.opponent.submodel')">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                                </div>
                            </div>
                        </div>

                        <!-- SECOND COLUMN - GENERAL -->
                        <div class="col-md-12 col-lg-6">
                            <div class="row">
                                <div class="col-sm-10">
                                    <div class="row no-gutters">
                                        <mat-form-field class="full-width">
                                            <mat-label>{{ case.accident.opponent.trans.plate_number | translate }}</mat-label>
                                            <input id="{{idPrefix}}{{case.accident.opponent.trans.plate_number}}"
                                                   type="text" matInput
                                                   [(ngModel)]="case.accident.opponent.plate_number"
                                                   (blur)="patchAndUpdate('accident.opponent.plate_number')"
                                                   uppercase>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-10">
                                    <div class="row no-gutters">
                                        <mat-form-field class="full-width">
                                            <mat-label>{{ case.accident.opponent.trans.comment | translate }}</mat-label>
                                            <textarea id="{{idPrefix}}{{case.accident.opponent.trans.comment}}"
                                                      matInput
                                                      rows="15"
                                                      [(ngModel)]="case.accident.opponent.comment"
                                                      (blur)="patchAndUpdate('accident.opponent.comment')">
                                            </textarea>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                            </div>
                        </div>

                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- RIGHT COLUMN WITH PARTICIPANT DETAILS -->

        <div class="col-sm-8" *ngIf="selectedParticipant">

            <mat-card>
                <mat-card-content>
                    <participant-details [idPrefix]="(idPrefix + 'selected.')"
                                         [bananaBox]="selectedParticipant"
                                         [participants]="participants"
                                         [case]="case"
                                         (caseUpdate)="patchAndUpdateWithValue($event)"
                                         (caseMultiUpdate)="patchOpDataArray($event)">
                    </participant-details>
                </mat-card-content>
            </mat-card>

        </div>

    </div>

</div>

